module.exports = __webpack_public_path__ + "static/media/male.3619595b.svg";